import { useEffect, useState, useMemo } from 'react';
import {
  Stack,
  Typography,
  Box,
  Paper,
  Button
} from '@mui/material';
import { Refresh as RefreshIcon, RefreshOutlined } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { CaseAnalyticsChart, CategoryAnalyticsChart } from '../case-analytics/features';
import { CaseDataTypeChart, CaseDataTypeAllChart } from './features';
import { useAnalyticsSyncDate } from "../../context/analytics-sync-date.context";

// Data type options as specified and exported for child components
export const DATA_TYPE_OPTIONS = [
  { label: 'All', value: undefined }, // No data_type parameter for 'All'
  { label: 'Follow Up Calls', value: 'followup_calls' },
  { label: 'New Data Current Month', value: 'new_data_current_month' },
  { label: 'New Data Current Month Delivered', value: 'new_data_current_month_delivered' },
  { label: 'Previous Months Unreached Calls', value: 'previous_months_unreached_calls' },
  { label: 'Previous Months Pending Calls', value: 'previous_months_pending_calls' }
];

export const CaseDataTypeAnalytics = (props) => {
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const { fromDate: syncedFromDate, toDate: syncedToDate, enableDateSync } = useAnalyticsSyncDate();

  const [fromDate, setFromDate] = useState(() => enableDateSync ? dayjs(syncedFromDate) : dayjs().startOf('month'));
  const [toDate, setToDate] = useState(() => enableDateSync ? dayjs(syncedToDate) : dayjs().endOf('month'));

  useEffect(() => {
    console.log('CaseDataTypeAnalytics sync date context', {
      fromDate: syncedFromDate,
      toDate: syncedToDate,
      enableDateSync,
    });

    // If date sync is enabled, update local state to match synced dates
    if (enableDateSync) {
      if (syncedFromDate) {
        setFromDate(dayjs(syncedFromDate));
      }
      if (syncedToDate) {
        setToDate(dayjs(syncedToDate));
      }
    }

  }, [syncedFromDate, syncedToDate, enableDateSync]);

  // refreshKey can be used to signal children to refetch when parent triggers a refresh
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        p: 3,
        border: '2px solid #e0e0e0',
        borderRadius: 2,
        backgroundColor: '#fafafa',
        overflowX: 'auto'
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Stack spacing={3} sx={{ flexGrow: 1 }}>
          <Typography variant="h4" gutterBottom>
            Case Analytics
          </Typography>

          <Paper elevation={2} sx={{ p: 3, mb: 0, border: '1px solid #d0d0d0' }}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">

            </Stack>
            <Typography variant="body2" color="textSecondary" sx={{ mt: 1, p: 1, border: '1px solid #e0e0e0', borderRadius: 1 }}>
              Note: This analytics is based on the 'callDate' field.
            </Typography>
          </Paper>

          {/* Child components manage their own loading/error states */}

          {/* Success State - Case Data Type Analytics Chart Components (side-by-side) */}
          {/* Child components manage their own fetching and date picking; pass initialDate and refreshKey to both */}
          <Stack direction="column" spacing={3} sx={{ width: '100%' }}>
            <Box>
              <CaseDataTypeChart
                title="Case Data Type Analytics"
                initialDate={selectedDate}
                initialFromDate={fromDate}
                initialToDate={toDate}
                refreshKey={refreshKey}
              />
            </Box>
            {/*
            <Box>
              <CaseDataTypeAllChart
                title="Case Data Type Analytics (All)"
                initialDate={selectedDate}
                refreshKey={refreshKey}
              />
            </Box>
            */}
          </Stack>
        </Stack>
      </LocalizationProvider>
    </Box>
  );
};
